<div>
  <span>
    <a href="https://isg-one.com/probenchmark-termsofuse" target="_blank" rel="noopener noreferrer" class="pb-trms">Terms of Use</a> &copy; {{todaysDate | date:'y'}} Information Services Group, Inc. All Rights Reserved.
  </span>
</div>
